import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useConfigStore = defineStore('config', () => {

    const appName           = '[UTA] UAZ Telematic Application'
    const httpServer        = ref('')
    const wsServer          = ref('')
    const imgServer         = 'https://aurus-status.its-telematics.com/web/sky_images/'
    const API_version       = 'v2'
    const yandexMapsSource  = 'https://api-maps.yandex.ru/v3/?apikey=2d592c08-43c9-4920-922d-c9602c0b4de8&lang=ru_RU'

    const setHttpServer     = data => httpServer.value = data
    const setWsServer       = data => wsServer.value = data

    return {

        appName,
        httpServer, 
        wsServer, 
        imgServer, 
        API_version, 
        yandexMapsSource, 
        setHttpServer, 
        setWsServer
    }
})
